export const COLORS = [
  '#0084F8',
  '#918DD9',
  '#21B65F',
  '#7DC6A9',
  '#57CAD9',
  '#564FC5',
  '#8434B1',
  '#9E3742',
  '#C60707',
  '#E70A70',
  '#E70A0A',
  '#F5A000',
  '#E7CB00',
  '#DAD743',
  '#C89704',
  '#9C9A8E',
  '#7E7D8E',
  '#4C4B65',
];
